import * as React from "react";
import { useTheme } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { createSinger, getSingers } from "../http/singerApi";
import { LOGIN_ROUTE } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../index";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const SingersAdder = observer(({ state, setState }) => {
  const { user } = React.useContext(Context);
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [singer, setSinger] = React.useState("");
  const [names, setNames] = React.useState([]);
  const navigate = useNavigate();

  const getData = async () => {
    try {
      const response = await getSingers();
      setNames(response);
      console.log(response);
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        user.setIsAuth(false);
        return navigate(LOGIN_ROUTE);
      }
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  const handleChangeSingers = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
    let singers = typeof value === "string" ? value.split(", ") : value;
    let artists = singers.map((singer) => {
      return {
        singer: singer,
        profitPercentage: 0,
      };
    });
    setState({
      ...state,
      singers: artists,
    });
  };

  const handleAddSinger = async () => {
    try {
      const response = await createSinger({ singer });
      console.log(response);
      getData();
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label">Singer</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          color="secondary"
          value={personName}
          onChange={handleChangeSingers}
          input={<OutlinedInput label="Singers" />}
          MenuProps={MenuProps}
        >
          {names.map(({ singer }) => (
            <MenuItem
              key={singer}
              value={singer}
              style={getStyles(singer, personName, theme)}
            >
              {singer}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        sx={{ m: 1, width: 300 }}
        variant="contained"
        color="secondary"
        onClick={handleOpen}
      >
        Добавить исполнителя
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Добавьте нового исполнителя
          </Typography>
          <FormControl sx={{ m: 1, width: 300 }}>
            <TextField
              label="Псевдоним исполнителя"
              variant="outlined"
              color="secondary"
              name="name"
              value={singer}
              onChange={(event) => setSinger(event.target.value)}
            />
          </FormControl>
          <Button
            onClick={handleAddSinger}
            disabled={false}
            variant="contained"
            color="secondary"
          >
            Добавить исполнителя
          </Button>
        </Box>
      </Modal>
    </>
  );
});

export default SingersAdder;
